import { Button } from 'react-bootstrap';
import Nav from 'react-bootstrap/Nav';
import Navbar from 'react-bootstrap/Navbar';
import NavDropdown from 'react-bootstrap/NavDropdown';
import { Container, Row, Col, Accordion } from 'react-bootstrap';
import Home from "./Home";
import { NavLink } from "react-router-dom";
import KwdcHeader from './LoginHeader';
import PublicSiteFooter from './PublicSiteFooter';
// import KwdcHeader from './Header';
export default function Aboutpage() {

    return (
        <>
            <KwdcHeader />



            <section className="kwdc-innerpage-about-top">
                <Container fluid className="p-0">
                    <Row className="g-0">
                        <Col xxl={8} xl={8} lg={8} md={8} sm={9} xs={9} className="kwdc-innerpage-about-left">
                            <div className="kwdc-innerpage-about-heading">
                                <h1>About us</h1>
                                <p>
                                    A.P. State Kapu Welfare & Development
                                    Corporation
                                </p>
                            </div>
                        </Col>

                        <Col xxl={4} xl={4} lg={4} md={4} sm={3} xs={3} className="kwdc-about-right"></Col>
                    </Row>
                </Container>
            </section>


            <section className="kwdc-innerpage-about-section">
                <Container>
                    <Row className="align-items-center">

                        <Col
                            xxl={7}
                            xl={7}
                            lg={7}
                            md={7}
                            sm={12}
                            xs={12}
                            className="order-2 order-md-1"
                        >
                            <div className="kwdc-innerpage-title-line"></div>

                            <p className="kwdc-innerpage-text">
                                The Government of Andhra Pradesh established the
                                A.P. State Kapu Welfare and Development
                                Corporation in 2015 with an aim to promote the
                                welfare and development of Kapu communities
                                including Kapu, Telaga, Balija and Ontari
                                sub-castes. The Corporation works towards the
                                social, educational and economic upliftment of
                                marginalized and poor Kapu community members in
                                Andhra Pradesh and strives to bring them on par
                                with other developed communities in society.
                            </p>

                            <h3 className="kwdc-h3">
                                <span className="orange-text">Our </span>

                                Objectives
                            </h3>

                            <div className="kwdc-objective-list">
                                <div className='kwdc-obj-inner'>
                                    <img src="../images/kwdc-side-arrow.svg" />
                                    <p>Ensure every eligible Kapu household
                                        benefits from at least one welfare scheme.
                                    </p>
                                </div>

                                <div className='kwdc-obj-inner'>
                                    <img src="../images/kwdc-side-arrow.svg" />
                                    <p>
                                        Provide quality educational opportunities
                                        and financial support.
                                    </p>
                                </div>

                                <div className='kwdc-obj-inner'>
                                    <img src="../images/kwdc-side-arrow.svg" />
                                    <p>
                                        Support economic upliftment and
                                        self-employment opportunities.
                                    </p></div>

                                <div className='kwdc-obj-inner'>
                                    <img src="../images/kwdc-side-arrow.svg" />
                                    <p>
                                        Build an equitable and inclusive society for
                                        all communities.
                                    </p></div>
                            </div>
                        </Col>

                        <Col
                            xxl={5}
                            xl={5}
                            lg={5}
                            md={5}
                            sm={12}
                            xs={12}
                            className="order-1 order-md-2"
                        >
                            <img
                                src="../images/kwdc-innerpage-about-img.webp"
                                alt="About"
                                className="img-fluid kwdc-innerpage-about-img"
                            />
                        </Col>

                    </Row>
                </Container>
            </section>
            <Container fluid className='kwdc-stat-cards-outerdiv'>
                <Container>
                    <h3 className="kwdc-h3 kwdc-stat-h3-marg">
                        <span className="orange-text"> Population </span>

                        Statistics
                    </h3>
                    <Row>
                        <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={12}>
                            <div className='kwdc-stat-card1'>

                                <div className='kwdc-stat-icon-circle'>
                                    <img src="../images/kwdc-stat-icon1.svg" className='img-fluid kwdc-stat-icon' />
                                </div>
                                <div className='kwdc-stat-line'></div>
                                <div>
                                    <h5 className='kwdc-stat-no'>
                                        50,54,813
                                    </h5>
                                    <p className='kwdc-stat-name'>Kapu Population</p>
                                </div>
                            </div>


                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={12}>
                            <div className='kwdc-stat-card1'>

                                <div className='kwdc-stat-icon-circle'>
                                    <img src="../images/kwdc-stat-icon2.svg" className='img-fluid kwdc-stat-icon' />
                                </div>
                                <div className='kwdc-stat-line'></div>
                                <div>
                                    <h5 className='kwdc-stat-no'>
                                        10.24%
                                    </h5>
                                    <p className='kwdc-stat-name'>State Population Share</p>
                                </div>
                            </div>

                        </Col>
                        <Col xxl={4} xl={4} lg={4} md={6} sm={6} xs={12}>
                            <div className='kwdc-stat-card1'>

                                <div className='kwdc-stat-icon-circle'>
                                    <img src="../images/kwdc-stat-icon3.svg" className='img-fluid kwdc-stat-icon' />
                                </div>
                                <div className='kwdc-stat-line'></div>
                                <div>
                                    <h5 className='kwdc-stat-no'>
                                        2011
                                    </h5>
                                    <p className='kwdc-stat-name'>State Pulse Survey</p>
                                </div>
                            </div>


                        </Col>
                    </Row>
                </Container>
            </Container >

            {/* ====================================about us============================== */}
            <section>

                <div className="kwdc-faq-wrapper">
                    <Container className='kwdc-accordian-container'>
                        <div className='kwdc-accordian-section'>
                            <h3 className="kwdc-h3 kwdc-stat-h3-marg">
                                <span className="orange-text"> Major </span>
                                Welfare Schemes
                            </h3>
                        </div>
                        <Accordion defaultActiveKey="" flush>
                            <Accordion.Item eventKey="0" className="kwdc-faq-item">
                                <Accordion.Header className='kwdc-accordian-header'>
                                    <span>01</span>
                                    NTR Bharosa Pensions
                                </Accordion.Header>
                                <Accordion.Body className='kwdc-accordian-body' >
                                    The Government is committed to the welfare and development of all segments of the Society. Enhancement of Pension
                                    amount is a major welfare measure to ameliorate the hardships of the poor and vulnerable sections of the society,
                                    particularly the old and infirm, widows, and person with disability etc.,to secure a dignified life. During the
                                    Financial years <span className="kwd-acc-sub-text">2024-25 to 2026-27 </span>pensions distributed for an amount of <span className="kwd-acc-sub-text">Rs.7615.57Cr. to 7,13,528 </span>kapu beneficiaries in the state.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="1" className="kwdc-faq-item">
                                <Accordion.Header className='kwdc-accordian-header'>
                                    <span>02</span>
                                    Thallikivandanam
                                </Accordion.Header>
                                <Accordion.Body className='kwdc-accordian-body' >
                                    An amount of <span className="kwd-acc-sub-text">Rs.724.47 Crores to 5,57,294 kapu beneficiaries </span>during the F.Y. <span className="kwd-acc-sub-text">2024-25 to 2026-27 </span>for
                                    providing financial assistance sanctioned to the mother/recognized guardians of the Kapu students
                                    @ Rs.15,000/- per student studying 1st to 12th standard. This scheme is implemented by School Education Department.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="2" className="kwdc-faq-item">
                                <Accordion.Header className='kwdc-accordian-header'>
                                    <span>03</span>
                                    Loan Waiver to SHG’s
                                </Accordion.Header>
                                <Accordion.Body className='kwdc-accordian-body' >
                                    TAn amount of <span className="kwd-acc-sub-text">Rs.633.73 Crores to 69,597 </span>Kapu women members of SHG during the F.Y.
                                    <span className="kwd-acc-sub-text">2024-25 to 2026-27 </span>for providing the financial assistance sanctioned to the Kapu
                                    women members of SHG groups for reimbursement of entire outstanding loans and it is implemented by SERP
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="3" className="kwdc-faq-item">
                                <Accordion.Header className='kwdc-accordian-header'>
                                    <span>04</span>
                                    Post Matric Scholarships (RTF)
                                </Accordion.Header>
                                <Accordion.Body className='kwdc-accordian-body' >
                                    The objective of the scheme is reimbursement of tuition fees to Kapu students whose parent’s annual
                                    income does not exceed Rs.2.50 Lakh per annum. Under the scheme there is full fee reimbursement
                                    for all degree courses as per Government fee structure. During the Financial years <span className="kwd-acc-sub-text">2024-25 to 2026-27</span>
                                    an amount of <span className="kwd-acc-sub-text">Rs.364.39 Crores</span> is allocated and it is implemented by Social Welfare Department.
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="4" className="kwdc-faq-item">
                                <Accordion.Header className='kwdc-accordian-header'>
                                    <span>05</span>
                                    Chandranna Videshi Vidya Deevena Scheme (Ambedkar Overseas Vidya Nidhi (AOVN))
                                </Accordion.Header>
                                <Accordion.Body className='kwdc-accordian-body' >
                                    Government has introduced the scheme Chandranna Videshi Vidya Deevena Scheme to provide Financial
                                    Assistance for Kapu students for perusing higher studies in foreign countries to complete PG/Phd,
                                    MBBS and other professional courses.<br></br>
                                    During the Financial years <span className="kwd-acc-sub-text">2015-16 to 2018-19</span> was selected the <span className="kwd-acc-sub-text">2234 Kapu students </span>and released
                                    an amount of <span className="kwd-acc-sub-text">Rs.111 crores to 1258 students </span>and pending an amount of <span className="kwd-acc-sub-text">Rs.161 crores </span>under this
                                    scheme for clearance of financial assistance to the students.<br></br>
                                    The former government was released the <span className="kwd-acc-sub-text">Rs.40.44 Cr to 743 kapu students</span> only during F.Y.
                                    the <span className="kwd-acc-sub-text">2015-16 to 2018-19 </span>under Chandranna Videshi Vidya Deevena Scheme.<br></br>
                                    During the Financial Years <span className="kwd-acc-sub-text">2019-20 to 2023-24 </span>the-then government was released for an
                                    amount of <span className="kwd-acc-sub-text">Rs.15.63 Crores to 60 Kapu Students </span>under Jaganna Videshi Vidya Deevena Scheme
                                    and released an amount of <span className="kwd-acc-sub-text">Rs.15.63 Crores.</span> And to be required for an amount of <span className="kwd-acc-sub-text">Rs.11.54
                                        Crores</span> to clear the pending dues.<br></br>
                                    During this government an amount of <span className="kwd-acc-sub-text">Rs.16.73 Crores was released to 200 Students</span> under this
                                    Scheme was cleared and an amount of <span className="kwd-acc-sub-text">Rs.80.83 Crores </span>is required for additional budget (pending dues)
                                    under Chandranna Videshi Vidya Deevena Scheme to clear the pending dues of <span className="kwd-acc-sub-text">959 kapu students.</span>
                                </Accordion.Body>
                            </Accordion.Item>
                            <Accordion.Item eventKey="5" className="kwdc-faq-item">
                                <Accordion.Header className='kwdc-accordian-header'>
                                    <span>06</span>
                                    Construction of Kapu Bhawans and Community Halls
                                </Accordion.Header>
                                <Accordion.Body className='kwdc-accordian-body' >
                                    The Government has proposed the establishment of ‘Kapu Bhawans’ at the headquarters of selected
                                    districts. These Bhawans are intended to serve as multipurpose facilities comprising function
                                    halls and hostel accommodations for public use, particularly benefiting students and members of
                                    the Kapu community. The scheme aims to provide a platform for interaction, social support,
                                    and community welfare.<br></br>
                                    The Government accorded administrative sanction for an amount of Rs.26.00 crores for the establishment
                                    of 13 District-Level Kapu Bhawans with a unit cost of Rs.2.00 crore each, vide G.O. Ms. No. 8, BC Welfare
                                    (C) Department, dated 31.05.2018.<br></br>
                                    Further, the Government sanctioned a total of 487 Mini Kapu Bhawans/Community Halls/Kalyana Mandapams
                                    with an allocation of Rs.146.15 crores during the financial years 2016-17 to 2018-19.<br></br>
                                    Subsequently, as per U.O. Note No. FIN01-FMU0ASD (WR1)/80/2019 (Comp. No. 898809), dated 29.05.2019,
                                    10 District-Level Kapu Bhawans and 421 Mini Kapu Bhawans that had not been grounded were cancelled.<br></br>
                                    Completed of (2) for Kapu Bhawans i.e., SPSR Nellore, and Visakhapatnam districts.<br></br>
                                    Nine Kapu Community Halls are completed in three districts i.e., Alamuru in East Godavari District,
                                    Jaggampeta in Kakinada district and (8) in Eluchuru, Pattepuram, Advipalem, Boddivarinipalem, Gudipudi
                                    and Chandaluru in Bapatla District. Remaining 56 Mini Kapu Bhawans works are in progress which are held
                                    up in various stages.<br></br>
                                    The previous government was sanctioned Kapu Community Hall on Vijayawada Central at NTR District and
                                    released at Rs.1.00 Crores only.
                                </Accordion.Body>
                            </Accordion.Item>


                        </Accordion>
                    </Container>
                </div >

            </section >


            <PublicSiteFooter />
        </>
    );
}







